<div class="child-opener">
    <gen-dynamic-form
            [formName]="widgetConfigPayload?.formId"
            [formConfig]="inputConfig"
            [editMode]="widgetConfigPayload?.editMode"
            [formData] = "formData"
            [disabled]="widgetConfigPayload?.disabled || disabled"
            [popupMode]="widgetConfigPayload?.popupMode"
            [formVertical]="widgetConfigPayload?.formVertical"
            [resetForm]="restForm"
            [stayInFormMode]="true"
            [requiredMessage]="''"
            [listenToDataChange]="widgetConfigPayload?.listenToDataChange"
            (formChange)="formChange($event.form)"
            (formInit)="onFormInit($event)"
    >
    </gen-dynamic-form>
    <gen-button *ngFor="let action of widgetConfigPayload.actions;let i=index"
                [text]="action?.name"
                [type]="action?.type"
                [iconClass]="action?.iconClass"
                (click)="openPopUpModal(i,action.actionMode)"
                class="{{action?.cssClass}}"
                [disabled]="widgetConfigPayload.disabled || disabled"
    ></gen-button>
</div>

<gen-dynamic-modal-loader class="lung-packyears-calculator-modal" [observableName]="ModalLoaderTunnelName"></gen-dynamic-modal-loader>